module.exports = __webpack_public_path__ + "img/door.d63fe7b2.png";